export const APP_MENU_SELECTED_KEY = 'app.menu.selectedKey'
export const APP_MENU_SELECTED_KEYS = 'app.menu.selectedKeys'
export const TEMPLATES_KEY = 'templates'
